/*
 * Copyright 2022 Siemens
 */

import {SwwcInformationBar} from '@com.siemens.plm.horizon/swwc/bindings/react';
import React from 'react';
import App from '../App';

export class Error404 extends React.Component {
  override render() {
    return (
      <SwwcInformationBar
        closable={false}
        buttonText='Home'
        onClickEvent={() => App.navigate('/')}
        fullWidthMode={true}
        informationText='Requested page is invalid'
        label='Not found'
        useIcon={true}
        variant='error'
      />
    );
  }
}
